import React from "react";
import { Grid, Typography, Divider, FormControl } from "@mui/material";
import { Controller } from "react-hook-form";
import SkeletonWrapper from "../Skeleton/SkeletonWrapper";
import TimezoneSelect, { type ITimezone } from "react-timezone-select";

const TimezoneSection = ({
  methods,
  showSkeleton,
  disabled = false,
  fullWidth = false,
  showDivider = true,
}) => (
  <>
    <Grid item xs={12}>
      <Typography variant="h6">Time Zone</Typography>
      <Typography className="font-size-12">
        Which time zone are you in?
      </Typography>
    </Grid>
    <Grid item xs={12} sm={fullWidth ? 12 : 6} md={fullWidth ? 12 : 6} lg={fullWidth ? 12 : 3}>
      <FormControl fullWidth>
        <SkeletonWrapper isLoading={showSkeleton} className="skeleton-input">
          <Controller
            control={methods.control}
            name={`availabilityData.timezoneValue`}
            render={({ field }) => (
              <TimezoneSelect
                {...field}
                id="timezoneValue"
                openMenuOnFocus
                isClearable
                isSearchable
                isDisabled={true}
                menuPortalTarget={document.querySelector("body")}
              />
            )}
          />
        </SkeletonWrapper>
      </FormControl>
    </Grid>
    {showDivider && (
      <Grid item xs={12}>
        <Divider />
      </Grid>
    )}
  </>
);

export default TimezoneSection;
